import styled from "styled-components";
import {MATERIALS_IMAGE} from "../../helper/materials";
import {ConfigurateurContext} from "../../context/context";

const {
    element: {
        useContext,
    },
} = wp;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
  
    & input[type=radio] {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }
    & input[type=radio] + .radio-image {
      cursor: pointer;          
    }
    & input[type=radio]:checked + .radio-image {
      border: 3px solid #144344;
      border-radius: 80px;
    }
    & label {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;
    }
`;
const ImageContainer = styled.div`
    border-radius: 80px;
    border: 1px solid #DBDBDB;
    & img {
      width: 160px;
      height: 160px;
    }
`;
const Title = styled.div`
    font-size: 24px;
    font-weight: 700;
`;
export default function CommandTypeItem({title, mType, imageUrl, handleSelect}) {

    const {type, setType} = useContext(ConfigurateurContext);

    const handleClick = () => {
        setType(mType);
        setTimeout(() => handleSelect(), 300);
    }
    return(
        <Wrapper>
            <label>
                <Title>{title}</Title>
                <input type="radio" name="command-type" value={mType} checked={mType === type} />
                <ImageContainer onClick={handleClick} className="radio-image">
                    <img src={imageUrl} alt={mType} />
                </ImageContainer>
            </label>

        </Wrapper>
    );
}